/** A player's jersey number before their name in a lineup row, if they have one. */
export const JerseyNumber = ({
  jerseyNumber,
}: {
  jerseyNumber: string | number | undefined;
}) => {
  const value = String(jerseyNumber ?? "");
  return value ? <span className="mr-2">#{value}</span> : null;
};
